"use strict";

angular.module('app.modals.scaleValue', [])

    .controller('scaleValueModalCtrl', ['$scope', 'close', 'Datapoints','Title',
        function ($scope, close, Datapoints,Title) {

           $scope.close = function () {
                close();
            };

            $scope.init = function () {
                $scope.Datapoints = Datapoints;
                $scope.Title = Title;
                
                Datapoints.forEach(function(dp) {
                    if (dp.DatapointConfig.canView && !dp.DatapointConfig.canWrite) {
                        if (dp.DatapointConfig.PossibleValues) {
                            dp._DisplayValue = dp.DatapointConfig.PossibleValues[dp.DatapointValue.Value];
                        } 
                        else {
                            dp._DisplayValue = dp.DatapointValue.Value;
                        }
                    }                    
                });
            }
            $scope.save = function () {

                close( $scope.Datapoints );
            }
            $scope.isDifferent = function(a,b)
            {
                return (!a ||!b || (a != b) );
            }
            $scope.dpCategoryTitles = {
                0:{DisplayName:'DATAPOINT_Category_0',ImageName:''},
                1:{DisplayName:'DATAPOINT_Category_1',ImageName:''},
                2:{DisplayName:'DATAPOINT_Category_2',ImageName:'icon-handbetrieb'},
                3:{DisplayName:'DATAPOINT_Category_3',ImageName:'icon-handbetrieb'},
                4:{DisplayName:'DATAPOINT_Category_4',ImageName:'icon-alarm'},
                5:{DisplayName:'DATAPOINT_Category_5',ImageName:'icon-alarm'},
                6:{DisplayName:'DATAPOINT_Category_6',ImageName:'icon-alarm'},
                7:{DisplayName:'DATAPOINT_Category_7',ImageName:'icon-alarm'},
                8:{DisplayName:'DATAPOINT_Category_8',ImageName:'icon-alarm'},
                9:{DisplayName:'DATAPOINT_Category_9',ImageName:'icon-anlagen-konfiguration'},
                10:{DisplayName:'DATAPOINT_Category_10',ImageName:''},
                11:{DisplayName:'DATAPOINT_Category_11',ImageName:'icon-scalevalue'},
            }
            $scope.hasError = () => {
                if (!$scope.Datapoints) return;
                return $scope.Datapoints.filter(dp => {
                    return dp.$UI.hasError === true;
                }).length;
            }
            $scope.init();
        }
    ])

    .factory('scaleValueModal', ['ModalService', '$q', function (ModalService, $q) {
        return function (Datapoints,Title) {
            return ModalService.showModal({
                templateUrl: "views/modals/datapointConfig.html",
                controller: 'scaleValueModalCtrl',
                inputs: {
                    Datapoints: Datapoints,
                    Title : Title
                }
            });

        }
    }]);
